import axios, { AxiosError, AxiosResponse } from "axios";

import { clearCookies } from "utils/components";
import { message as toaster } from "antd";

export const globalDomain = process.env.REACT_APP_API_URL;

interface IErrorStatus {
  [key: number | string]: (error: AxiosError<AxiosErrorResponse>) => any;
}

let authErrors: (AxiosResponse<AxiosErrorResponse, any> | undefined)[] = [];

//Retorno de mensagens de erro
const errosStatusMessage = {
  400: (error) => {

    const data = error.response?.data
    const message = data?.log ?? data?.message ?? "Requisição inválida";

    return { ...data, message };
  },
  401: (error) => {

    //limpa o storage e da reload na pagina
    clearCookies();
    window.location.reload();

    return {
      unauthenticated: true,
      message: "Usuário não autenticado, faça login novamente",
    };

  },
  403: (error) => {
    const message =
      error?.response?.data?.message ??
      "Você não tem permissão para acessar esse recurso";
    return { ...error, message };
  },
  404: () => {
    return { message: "Recurso não encontrado" };
  },
  406: (error) => {
    const message =
      error?.response?.data?.message ??
      "Não foi possível processar a requisição";
    return { message };
  },
  419: (error) => {
    localStorage.clear();
    clearCookies();
    errosStatusMessage[401](error);
  },
  422: (error) => {
    const messages = error?.response?.data?.errors;
    for (const key in messages) {
      if (messages.hasOwnProperty(key)) toaster.error(messages[key][0]);
    }

    return { messages };
  },
  429: () => {
    return { message: "Muitas requisições, tente novamente mais tarde" };
  },
  500: () => {
    return { message: "Erro interno do servidor" };
  },
} as IErrorStatus;


export const Api = axios.create({
  baseURL: globalDomain,
  withCredentials: true,
});



//Interceptores de requisição para tratar os erros
Api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error: AxiosError<AxiosErrorResponse>) => {

    const status = error?.response?.status as number;

    if (status === 401 || status === 419) authErrors.push(error.response);

    if (authErrors.length > 1) {
      localStorage.clear();
      clearCookies();
      authErrors = []
    }

    if (errosStatusMessage[status])
      return Promise.reject({
        ...error,
        ...errosStatusMessage[status](error),
      });
    else
      return Promise.reject({
        ...error,
        message: "Ocorreu um erro inesperado, tente novamente mais tarde",
      });
  }
);

Api.interceptors.request.use(
  (config) => {
    //Autenticação do usuário
    config!.headers!.xsrfCookieName = "XSRF-TOKEN";
    config!.headers!.xsrfHeaderName = "X-XSRF-TOKEN";

    //Aplicação concatenar json e html
    config!.headers!.Accept = "application/json, text/html";

    return config;
  },
  (error: AxiosError<AxiosErrorResponse>) => {
    const status = error?.response?.status as number;

    if (status === 401 || status === 419) authErrors.push(error.response);

    if (authErrors.length > 1) {
      localStorage.clear();
      clearCookies();
      authErrors = []
    }

    if (errosStatusMessage[status])
      return Promise.reject({
        ...error,
        ...errosStatusMessage[status](error),
      });
    else
      return Promise.reject({
        ...error,
        message: "Ocorreu um erro inesperado, tente novamente mais tarde",
      });
  }
);
